export default function menuLink() {
  return {
    scope: {
      section: '='
    },
    template: '<md-button ' +
      '  ng-if="!section.hidden"' +
      '  ng-class="{\'{{section.icon}}\' : true, \'disabled\':section.disabled}" \n' +
      '  ui-sref-active="active" ui-sref="{{section.state}}" ' +
      '  ng-disabled="section.disabled"' +
      '  ng-click="focusSection()">\n' +
      '  {{section | humanizeDoc}}\n' +
      '  <span class="md-visually-hidden "\n' +
      '    ng-if="isSelected()">\n' +
      '    current page\n' +
      '  </span>\n' +
      '</md-button>\n',
    link: function ($scope, $element) {
      const controller = $element.parent().controller();

      $scope.focusSection = function () {
        // set flag to be used later when
        // $locationChangeSuccess calls openPage()
        controller.autoFocusContent = true;
      };
    }
  };
}
